<template>
    <div class="inteqt mt-5">
      <video playsinline autoplay muted loop class="rounded mx-auto d-block w-100">
        <source src="https://res.cloudinary.com/dmhhkhgny/video/upload/v1745406688/website/vzw7z92zdvomwfvwlguc.mp4" />
      </video>
    </div>
  </template>
  
  <script>
  export default {
    name: 'InteqtComponent'
  };
  </script>
  
  <style scoped>
  :root {
    --typewriterSpeed: 6s;
    --typewriterCharacters: 40;
  }
  
.inteqt{
    position: unset;
    width: 99vw;
    margin-left: 0px;
}
  
  .inteqt-container {
    position: absolute;
    left: 10%;
    top: 50%;
    z-index: 1;
    font-family: 'Source Sans Pro', sans-serif;
  }
  
  @media (max-width: 1200px) { 
    .inteqt-container {
      left: 8%;
    }
  }
  
  @media (max-width: 992px) { 
    .inteqt-container {
      top: 40%;
      left: 5%;
    }
  }
  
  .inteqt__link {
    text-decoration: none;
    color: white;
  }
  
  .inteqt__link:hover {
    color: #00AEEF; 
  }
  
  .inteqt__subtitle {
    color: white;
    font-size: 2rem;
    font-weight: bold;
    opacity: 0;
    transform: translateY(3rem);
    animation: fadeInUp 4s ease calc(var(--typewriterSpeed) + 1s) infinite;
  }
  
  @media (max-width: 768px) {
    .inteqt__subtitle {
      font-size: 1.5rem;
    }
  }
  
  @media (max-width: 576px) { 
    .inteqt__subtitle {
      font-size: 1rem;
    }
  }
  
  .header-animated {
    font-family: 'Source Code Pro', monospace;
    font-size: clamp(1rem, 3vw + 1rem, 5.2rem);
    font-weight: bold;
    position: relative;
    width: max-content;
    margin: auto;
    color: white;
  }
  
  @media (max-width: 1400px) { 
    .header-animated {
      font-size: clamp(1rem, 3vw + 1rem, 4rem);
    }
  }
  
  @media (max-width: 1200px) { 
    .header-animated {
      font-size: clamp(1rem, 3vw + 1rem, 3rem);
    }
  }
  
  @media (max-width: 992px) {
    .header-animated {
      font-size: clamp(1rem, 3vw + 1rem, 3rem);
    }
  }
  
  @media (max-width: 768px) { 
    .header-animated {
      font-size: clamp(1rem, 3vw + 1rem, 1.8rem);
    }
  }
  
  @media (max-width: 576px) { 
    .header-animated {
      font-size: 1rem;
    }
  }
  
  .header-animated::before,
  .header-animated::after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }
  
  .header-animated::before {
    background: rgba(0, 0, 0, 0.5);
    animation: typewriter var(--typewriterSpeed) steps(var(--typewriterCharacters)) 1s infinite;
  }
  
  .header-animated::after {
    width: 0.125em;
    background: white;
    animation: typewriter var(--typewriterSpeed) steps(var(--typewriterCharacters)) 1s infinite,
               blink 300ms steps(var(--typewriterCharacters)) infinite;
  }
  
  @keyframes typewriter {
    to {
      left: 100%;
    }
  }
  
  @keyframes blink {
    to {
      background: transparent;
    }
  }
  
  @keyframes fadeInUp {
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
</style>
  